// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import { 
    ReactNode
} from "react"

import { 
    LoadingOverlay 
} from "@mantine/core"

// Imports from vseth-canine-ui


import { 
    useAppSelector 
} from "../../hooks/useAppSelector"

import { 
    useAppDispatch 
} from "../../hooks/useAppDispatch"


// Imports from this projects
// Pages, Components, Features, Hooks
import { 
    AuthState,
    selectTokens, 
    setAuthState 
} from "../../features/auth/authSlice"

import { 
    getAuthStateFromToken 
} from "../../util/getAuthStateFromToken"
import { AuthProvider } from "./AuthProvider"


//Define interface
type CustomAuthProviderProps = {
    children: ReactNode
}


/**
 * The AdminPage component renders the admin page of the application.
 */
export const CustomAuthProvider = (props: CustomAuthProviderProps) => {
    const tokens = useAppSelector(selectTokens)
    const dispatch = useAppDispatch()

   
    
    return (
        <AuthProvider
            setAuthState ={(authState: AuthState) => {
                dispatch(setAuthState(authState))
            }}
            authState={getAuthStateFromToken(tokens)}
            LoadingComponent={<LoadingOverlay visible={true}/>}          
        >
            {props.children}
        </AuthProvider>
    )
}
